<template>
  <div class="container-fluid container-select-items">
    <div class="row">
      <div class="col-12">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 text-center">
              <p v-if="$parent.$parent.currentNavigation !== 'overview' && $parent.$parent.currentNavigation !== 'name'"
                 class="text-danger select-items text-start">
                {{ $t('Set.SelectItem.hint') }}
              </p>
              <h5 v-else class="select-items text-center">{{ $t('Common.all') }} {{ $t('Common.items') }}</h5>
            </div>
          </div>
          <!--
          <div class="row overview-menu" v-if="($parent.$parent.currentNavigation === 'overview' || $parent.$parent.currentNavigation === 'name') && $parent.$parent.showSideMenu === false">
            <div class="col-12 text-center" v-for="(menuPoint, index) in menuList" v-bind:key="index">
              <div class="overview-menu-btn" v-if="index === 'stones' && !menuList['stones/jewellery/normal'] && !menuList['stones/jewellery/model']">
                <a @click="configure(index)">{{ menuPoint }}</a>
              </div>
              <div class="overview-menu-btn" v-else-if="index !== 'stones'">
                <a @click="configure(index)">{{ menuPoint }}</a>
              </div>
            </div>
          </div>
          -->
          <div class="row item-row" v-for="itemId in getItems" v-bind:key="itemId">
            <table id="TableSelectItems" class="table table-responsive">
              <tr>
                <td @click="switchCurrentItem(itemId)">
                  <img v-if="set.items[itemId].description.jewelleryType == 5"
                       :ref="'currentItem' + itemId"
                       @error="setImagePlaceholder($refs['currentItem' + itemId])"
                       :src="appUrl +'/img/assets/stones/exchange/stone_' + set.items[itemId].description.stones.diamondStock.stoneform.toLowerCase() + '.jpg'"
                       :alt="set.items[itemId].itemnumber.toUpperCase()"/>
                  <img v-else
                       :ref="'currentItem' + itemId"
                       @error="setImagePlaceholder($refs['currentItem' + itemId])"
                       :src="getApiHost + '/v2/images/item/ffffff/600/600/' + set.items[itemId].itemnumber.toUpperCase() + '.jpg'"
                       :alt="set.items[itemId].itemnumber.toUpperCase()"/>
                </td>
                <td @click="switchCurrentItem(itemId)">
                  <h5>
                    <template v-if="set.items[itemId].name !== ''">
                      {{ set.items[itemId].name }}
                    </template>
                    <template v-else>
                      {{ $t('Set.SelectItem.item') }} {{ itemId + 1 }}
                    </template>
                  </h5>
                  {{ set.items[itemId].itemnumber }}
                </td>
                <td>
                  <img @click="dropItem(itemId)" :src="appUrl + '/img/icons/drop.svg'" class="icon" :alt="$t('Set.Overview.item.button.delete')"/>
                  <br/>
                  <CopyIcon :textToCopy="set.items[itemId].itemnumber.toUpperCase()" iconWidth="2.5" feedback="icon"/>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Config from "@/vuex/Config";
  import MenuList from "@/assets/Helper/MenuList";
  import SetData from "@/vuex/SetData";
  import CopyIcon from "@/components/Icons/Copy";

  export default {
    name: 'SelectItems',
    props: [
      'items',
      'set'
    ],
    components: {
      CopyIcon
    },
    updated() {
      this.handleAfterIsPopState();
    },
    created() {
      window.addEventListener("resize", () => {
        setTimeout(() => {
          //this.$root.$emit('setOverview');
          this.$root.$emit('checkWishlistIcon');
          this.$root.$emit('checkWishlistButton');

          this.$parent.$parent.$parent.$data['resizeTriggered'] = false;
        }, 250);
      });
    },
    mounted() {
      this.handleAfterIsPopState();
    },
    data() {
      return {
        getApiHost: Config.getters.getApiHost,
        appUrl: Config.getters.getAppUrl
      }
    },
    methods: {
      setImagePlaceholder(itemNode) {
        if (itemNode && itemNode[0]) {
          itemNode[0].src = this.appUrl + '/img/assets/not-available.jpg';
        }
      },
      configure: function (type) {
        Config.dispatch("setCurrentVarType", type).then(() => this.$root.$emit('hideLoader3D'));
      },
      handleAfterIsPopState: function() {
        if (history && typeof history.state == 'object' && history.state.ispopstate === true) {
          history.state.ispopstate = false;
          this.$parent.$parent.currentNavigation = 'overview';

          if (this.items.length > 1) {
            setTimeout(() => {
              this.switchCurrentItem('overview');
            });
          }
          this.$root.$emit('updateViewer');
        }
      },
      switchCurrentItem: function (newCurrentItem) {
        let isItemWeddingRing = this.$parent.$parent['isCurrentItemWeddingRing'](newCurrentItem);
        let currentVarType = Config.getters.getcurrentVarType;

        if (isItemWeddingRing && (currentVarType === 'stones/jewellery/normal' || currentVarType === 'stones/jewellery/model')) {
          Config.dispatch('setCurrentVarType', 'jewellery/stones');
        }

        this.$parent.$parent.$parent['setCurrentItem'](newCurrentItem);

        if (Config.getters.getcurrentVarType !== '') {
          this.$root.$emit('configure');
        }
      },
      dropItem: function (itemKey) {
        Config.dispatch('setVisualMode', "show").then(() => {
          Config.dispatch('setCurrentVarType', "");
        });

        SetData.dispatch('dropItem', itemKey);

        this.$parent.$parent.$parent['reset3d'](true);
        this.$parent.$parent.$parent['setCurrentItem']('overview');
      },
    },
    computed: {
      menuList: function () {
        return MenuList.get(this.set.currentItem);
      },
      getItems: function() {
        let items = this.items;
        if (typeof items[0] == 'undefined' && this.set.items) {
          items = [];
          for (let i in this.set.items) {
            items[i] = i;
          }
        }
        return items;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #app {
    .item-row {
      border-bottom: solid 0.05em $borderColor;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      h5 {
        margin-top: 2.5rem;
      }

      img {
        width: 6em;
        height: auto;
      }
    }

    .container-select-items {
      background-color: $white;
    }

    #TableSelectItems {
      margin-top: 2rem;
      border: none;

      h5 {
        margin-top: 0;
      }

      tr {
        td {
          vertical-align: middle;

          .icon {
            display: inline-block;
            padding: 0.5rem;
            margin: 0.5rem;
            max-width: 2.5rem;
            text-align: center;
          }
        }

        td:first-child {
          text-align: left;
          width: 25%;
        }

        td:nth-child(2) {
          width: 65%;
          padding-left: 1rem;
        }

        td:last-child {
          text-align: right;
        }
      }
    }

    .select-items {
      margin-top: 2.2rem;
    }

    h5.select-items {
      display: inline-block;
      width: 100%;
      padding: 1.35rem;
      border-bottom: solid 0.1em $borderColor;
    }

    .overview-menu {
      margin-top: 0rem;
      margin-bottom: 2rem;

      .overview-menu-btn {
        padding-top: 0.3em;
        cursor: pointer;
        position: relative;
        border-bottom: 0.1rem solid $borderColor;

        &:hover {
          background-color: $lightGreyBg;
        }

        a {
            letter-spacing: 0.1em;
            text-align: center;
            font-weight: normal;
            line-height: 4rem;
            width: 99%;
            display: block;

            &:hover {
              text-decoration: none;
            }
        }
      }
    }
  }
</style>
